import { DocumentationTranslationKeys } from 'intl/keys';
import type { TranslationKey } from 'intl/types/translationKey';

/** Tells that a version was added to a documentation, and whether it became the current one (PT-7117). */
export function versionAddedToastKey(makeCurrent: boolean): TranslationKey {
  if (makeCurrent) {
    return DocumentationTranslationKeys.versionAddedAsCurrentToast;
  }
  return DocumentationTranslationKeys.versionAddedToast;
}
